import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { Loader } from '../components/common';
import { useClearState } from '../hooks';

function SignoutRedirect() {
  const navigate = useNavigate();
  const clearState = useClearState();

  useEffect(() => {
    clearState();
    navigate('/');
  }, []);

  return <Loader />;
}

export default SignoutRedirect;
